import React from "react";
import { Link } from "react-router-dom";
import { Container, Grid, Typography, Box } from "@mui/material";

const Footer: React.FC = () => {
  return (
    <>
      <Box component="footer" sx={{ backgroundColor: "#101010", color: "#fff", py: 4, position: "relative" }}>
        <Container maxWidth="xl">
          <Grid container spacing={4}>
            <Grid item xs={12} md={4} sx={{textAlign: {xs:'center', md: 'left'}, display: "flex", flexDirection: "column"}} >
              <Link
                to="/privacy-policy"
                style={{ textDecoration: "none", fontFamily: "'Space Grotesk', sans-serif" }}
                aria-label="Vai alla Privacy Policy"
                className="footer-link"
              >
                Privacy Policy
              </Link>
              <Link
                to="/cookie-policy"
                style={{ textDecoration: "none", fontFamily: "'Space Grotesk', sans-serif" }}
                aria-label="Vai alla Cookie Policy"
                className="footer-link"
              >
                Cookie Policy
              </Link>
              <Link
                to="/accessibilita"
                style={{ textDecoration: "none", fontFamily: "'Space Grotesk', sans-serif" }}
                aria-label="Vai alla Dichiarazione di Accessibilità"
                className="footer-link"
              >
                Accessibilità
              </Link>
              <Link
                to="/trasparenza-ia"
                style={{ textDecoration: "none", fontFamily: "'Space Grotesk', sans-serif" }}
                aria-label="Vai alla pagina Trasparenza IA"
                className="footer-link"
              >
                Trasparenza IA
              </Link>
            </Grid>

            <Grid item xs={12} md={4} sx={{textAlign: 'center'}}>
              <img src="/loghi/sito/logo.png" alt="CAMILLACINODESIGN&DEV" style={{ maxHeight: '50px', objectFit: 'contain' }} />
            </Grid>

            <Grid item xs={12} md={4} sx={{textAlign: 'center'}}>
              <Typography variant="body2" sx={{ textAlign: {xs: 'center', md: 'left'}, fontFamily: "'Space Grotesk', sans-serif" }}><b>Sede Legale:</b> <br></br> <a href="https://maps.app.goo.gl/BQYJGGXAhvYHsSav6" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ textDecoration: 'none' }}>via Per S. Felice 3 - Camposanto (MO) - 41031</a></Typography>
              <Typography variant="body2" sx={{ textAlign: {xs: 'center', md: 'left'}, fontFamily: "'Space Grotesk', sans-serif" }}>P.iva: 04601200167</Typography>
            </Grid>

          </Grid>

          <Box textAlign="center" mt={3} sx={{textAlign: 'center'}}>
            <Typography variant="body2" sx={{ fontFamily: "'Space Grotesk', sans-serif" }}>&copy; {new Date().getFullYear()} CAMILLACINODESIGN&DEV. Tutti i diritti riservati.</Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Footer;